import { lazy, Suspense, useState } from 'react';
import { motion } from 'framer-motion' 
import styled, { keyframes } from 'styled-components'
import { NavLink } from 'react-router-dom'
import axios from 'axios'

import DataUsageIcon from '@material-ui/icons/DataUsage';
import Loading from "../subComponents/Loading";
import cat from "../assets/Images/cat01_run_12fps.gif"
//components
import PowerButton from "../subComponents/PowerButton"
import LogoComponent from "../subComponents/LogoComponent"
import SocialIcons from "../subComponents/SocialIcons"
import Intro from "../components/Intro"
import { mediaQueries } from "./Themes";

const MainContainer = styled(motion.div)`
background: ${props => props.theme.body};
width: 100vw;
height: 100vh;
overflow: hidden;

position: relative;

h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Karla", sans-serif;

    font-weight: 500;
  }

  h2 {
    ${mediaQueries(40)`
      font-size:1.2em;

  `};

    ${mediaQueries(30)`
      font-size:1em;

  `};
  }
}
`

const Container = styled.div`
padding: 2rem;
`

const Contact = styled.div`
color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
position: absolute;
top: 2rem;
right: calc(1rem + 2vw);
text-decoration: none;
z-index: 1;
font-family: 'Ubuntu Mono', monospace;
font-size: 24px;
width: auto;
`

const Joke = styled.div`
color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
position: absolute;
top: 2.8rem;
text-decoration: none;
z-index: 1;
font-family: 'Ubuntu Mono', monospace;
font-size: 16px;
max-width: 96vw;
right: 0;
text-align: right;

@media only screen and (max-width: 51.75em) {
    white-space: now;
    width: 96vw;
    right: 0vw;
    height: ${(props) => (props.click ? "80px" : "100px")};
}
@media only screen and (max-width: 30em) {
    width: 96vw;
    right: 0vw;
    height: ${(props) => (props.click ? "40px" : "100px")};
}
`

const BLOG = styled(NavLink)`
  color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
  position: absolute;
  top: 50%;
  right: calc(1rem + 2vw);
  transform: rotate(90deg) translate(-50%, -50%);
  z-index: 1;

  text-decoration: none;
  @media only screen and (max-width: 51.75em) {
    text-shadow: ${(props) => (props.click ? "0 0 4px #000" : "none")};
  }
`;
const WORK = styled(NavLink)`
color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
position: absolute;
top: 50%;
left: 2rem;
transform: translate(-50%, -50%) rotate(-90deg); 
text-decoration: none;
z-index: 1;
@media only screen and (max-width: 51.75em) {
    text-shadow: ${(props) => (props.click ? "0 0 4px #000" : "none")};
}
`

const BottomBar = styled.div`
position: absolute;
bottom: 1rem;
left: 0;
right: 0;
width: 100%;

display: flex;
justify-content: space-evenly;
`

const ABOUT = styled(NavLink)`
  color: ${(props) => (props.click ? props.theme.body : props.theme.text)};
  text-decoration: none;
  z-index: 1;
`;

const SKILLS = styled(NavLink)`
color: ${props => props.theme.text};
text-decoration: none;
z-index: 1;
`

const rotate = keyframes`
from{
    transform: rotate(0);
}
to{
    transform: rotate(360deg);
}
`

const Center = styled.button`
position: absolute;
top: ${props => props.click ? '92%' : '50%'};
left: ${props => props.click ? '96%' : '50%'};
transform: translate(-50%, -50%);
border: none;
outline: none;
background-color: transparent;
cursor: pointer;
font-family: 'Ubuntu Mono', monospace;
font-size: 24px;

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
transition: all 1s ease;

&>:first-child{
    animation: ${rotate} infinite 1.5s linear;
    font-size: 200px;
}

&>:last-child{
    display: ${props => props.click ? 'none' : 'inline-block'};
    padding-top: 1rem;

    @media only screen and (max-width: 51.75em) {
    top: ${(props) => (props.click ? "90%" : "50%")};
    left: ${(props) => (props.click ? "90%" : "50%")};
    width: ${(props) => (props.click ? "80px" : "150px")};
    height: ${(props) => (props.click ? "80px" : "100px")};
  }
  @media only screen and (max-width: 30em) {
    width: ${(props) => (props.click ? "40px" : "150px")};
    height: ${(props) => (props.click ? "40px" : "100px")};
  }
}
`

const DarkDiv = styled.div`
position: absolute;
top: 0;
background-color: #000;
bottom: 0;
right: 50%;
width: ${props => props.click? '50%' : '0%'};
height: ${props => props.click? '100%' : '0%'};
z-index: 1;
transition: height 0.5s ease, width 1s ease 0.5s;

${(props) =>
    props.click
      ? mediaQueries(50)`
       height: 50%;
  right:0;
  
  width: 100%;
  transition: width 0.5s ease, height 1s ease 0.5s;

  `
      : mediaQueries(50)`
       height: 0;
  
  width: 0;
  `};
`

const run = keyframes`
from{
    transform: scale(8) translateX(0vw);
}
to{
    transform: scale(8) translateX(20vw);
}
`

const tinyrun = keyframes`
from{
    transform: scale(4) translateX(0vw);
}
to{
    transform: scale(4) translateX(60vw);
}
`

const Cat = styled.div`
position: absolute;
top: 88%;
right: 110%;
width:32px;
transform: scale(8);
image-rendering: pixelated;
animation: ${run} infinite 10s linear;

@media only screen and (max-width: 51.75em) {
    display: none;
}
@media only screen and (max-width: 30em) {
    display: none;
}
`

const Email = styled.div`
position: absolute;
top: 4rem;
left: 2rem;
font-family: 'Ubuntu Mono', monospace;

@media only screen and (max-width: 51.75em) {
    position: absolute;
    transform: translate(50%, 50%);
    top: 20%;
    left: 50$;
}
@media only screen and (max-width: 30em) {
    position: absolute;
    top: 20%;
    left: 50$;
}
`

export const Main = () => {
    
    const [joke, setJoke] = useState("");
    const [jokeSetup, setJokeSetup] = useState("");
    const [jokeDelivery, setJokeDelivery] = useState("");
    const [click, setClick] = useState(false);
    const [path, setpath] = useState("");

    const jokeClick = () => {
        axios.get('https://v2.jokeapi.dev/joke/Programming').then(res => {
        console.log(res.data)
        setJoke(res.data.joke)
        setJokeSetup(res.data.setup)
        setJokeDelivery(res.data.delivery)
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleClick = () => setClick(!click);

    const moveY = {
        y: "-100%",
      };
      const moveX = {
        x: `${path === "work" ? "100%" : "-100%"}`,
      };
      const mq = window.matchMedia("(max-width: 51.75em)").matches;

    return (
        <Suspense fallback={<Loading />}>

        <MainContainer
            key="modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={path === "about" || path === "skills" ? moveY : moveX}
            transition={{ duration: 0.5 }}
        >
        <DarkDiv click={click}/>
            <Container>
            <LogoComponent theme={click ? "dark" : "light"} />
            <Email>benmrtnz27@gmail.com</Email>
            <PowerButton />
            {mq ? (
                <SocialIcons theme="light" />
            ) : (
                <SocialIcons theme={click ? "dark" : "light"} />
            )}
                <Center click={click}>
                    <DataUsageIcon onClick={() => handleClick()} style={click ? { fontSize: 80} : {fontSize: 200}} fill='currentColor'/>
                    <span>Click Here</span>
                    </Center>
                    {mq ? (
                    <Contact onClick={() => jokeClick()}>
                        <motion.h3
                        initial={{
                            y: -200,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        animate={{
                            y: 0,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        >
                        Get Joke
                        <Joke>{joke}{jokeSetup} {jokeDelivery}</Joke>
                        </motion.h3>
                    </Contact>
                    ) : (
                    <Contact onClick={() => jokeClick()}>
                        <motion.h3
                        initial={{
                            y: -200,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        animate={{
                            y: 0,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        >
                        Get Joke
                        <Joke>{joke}{jokeSetup} {jokeDelivery}</Joke>
                        </motion.h3>
                    </Contact>
                    )}

                    {mq ? (
                    <BLOG click={+click} onClick={() => setpath("blog")} to="/blog">
                        <motion.h2
                        initial={{
                            y: -200,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        animate={{
                            y: 0,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        >
                        Game
                        </motion.h2>
                    </BLOG>
                    ) : (
                    <BLOG click={+false} onClick={() => setpath("blog")} to="/blog">
                        <motion.h2
                        initial={{
                            y: -200,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        animate={{
                            y: 0,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        >
                        Game
                        </motion.h2>
                    </BLOG>
                    )}

                    <WORK click={+click} to="/work">
                    <motion.h2
                        onClick={() => setpath("work")}
                        initial={{
                        y: -200,
                        transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        animate={{
                        y: 0,
                        transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                    >
                        Work
                    </motion.h2>
                    </WORK>

                    <BottomBar>
                    <ABOUT
                        onClick={() => setClick(false)}
                        click={mq ? +false : +click}
                        to="/about"
                    >
                        <motion.h2
                        onClick={() => setpath("about")}
                        initial={{
                            y: 200,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        animate={{
                            y: 0,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        >
                        About
                        </motion.h2>
                    </ABOUT>

                    <SKILLS to="/skills">
                        <motion.h2
                        onClick={() => setpath("skills")}
                        initial={{
                            y: 200,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        animate={{
                            y: 0,
                            transition: { type: "spring", duration: 1.5, delay: 1 },
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        >
                        Skills
                        </motion.h2>
                    </SKILLS>
                    </BottomBar>
                    <Cat>
                        <img src={cat}></img>
                    </Cat>
                    </Container>

                    {click ? <Intro click={click} /> : null}
                    </MainContainer>
                    </Suspense>
                    );
};


export default Main
